import React from 'react'
import {
  CardContainer,
  Shimmer,
  BasicCardContainer,
  HeaderSection,
  HeaderLeft
} from './style'
import ShimmerEffect from './ShimmerEffect'
import CardShimmer from './CardShimmer'
import { useResponsive } from 'shared-ui/hooks'
import { media } from 'shared-ui/utils/media'

function NotificationCardShimmer({ className, style }) {
  return (
    <div
      className={className}
      style={{
        width: '100%',
        minHeight: '64px',
        background: '#0F0F12',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        ...style
      }}
    >
      <div className="w-2.5 flex-shrink-0" />
      <Shimmer width={'44px'} height={'44px'} radius="50%" className="flex-shrink-0" />
      <div className="flex-1 min-w-0 flex flex-col justify-center gap-1.5">
        <Shimmer width={'50%'} height={'14px'} radius="4px" />
        <Shimmer width={'75%'} height={'12px'} radius="4px" />
      </div>
      <Shimmer width={'56px'} height={'56px'} radius="12px" className="flex-shrink-0" />
    </div>
  )
}

function CreatorCardShimmer({ className }) {
  return (
    <CardContainer
      width={'100%'}
      height={'121px'}
      radius={'4px'}
      className={className}
    >
      <Shimmer width={'89px'} height={'89px'} radius="50%" />
      <div>
        <Shimmer
          width={'209px'}
          height={'14px'}
          radius="4px"
          className="mb-1"
        />
        <Shimmer width={'159px'} height={'14px'} radius="4px" />
      </div>
      <Shimmer width={'93px'} height={'40px'} radius="32px" />
    </CardContainer>
  )
}
function BlockUserShimmer({ className }) {
  return (
    <div
      className={className}
    >
      <Shimmer width={'89px'} height={'89px'} radius="50%" />
      <div>
        <Shimmer
          width={'209px'}
          height={'14px'}
          radius="4px"
          className="mb-1"
        />
        <Shimmer width={'159px'} height={'14px'} radius="4px" />
      </div>
      <Shimmer width={'93px'} height={'40px'} radius="32px" />
    </div>
  )
}
//discoverpage list
function CustomDiscoverCardShimmer() {
  const isMobile = useResponsive(media.mobile)

  return (
    <div className="mb-8">
      <div className="flex justify-between">
        <div className="flex items-center">
          <ShimmerEffect height="32px" width="32px" radius="50%" />
          <div className="ml-2">
            <ShimmerEffect
              height="14px"
              width="87px"
              radius="4px"
              className="mb-1"
            />
            <ShimmerEffect height="14px" width="87px" radius="4px" />
          </div>
        </div>
        <div className="flex items-center">
          <ShimmerEffect
            height="14px"
            width="40px"
            radius="4px"
            className="mr-2"
          />
          <ShimmerEffect height="24px" width="24px" radius="4px" />
        </div>
      </div>
      <CardContainer
        width={'100%'}
        height={isMobile ? '214px' : '315px'}
        radius={'4px'}
        className="flex flex-col justify-between p-2 my-2"
      >
        <div></div>
        <div>
          <Shimmer
            width={'309px'}
            height={'27px'}
            radius="4px"
            className="mb-1"
          />
          <Shimmer width={'142px'} height={'14px'} radius="4px" />
        </div>
      </CardContainer>
      <div className="flex justify-between">
        <CardContainer width={'221px'} height={'40px'} radius="4px" />
        <CardContainer width={'93px'} height={'40px'} radius="32px" />
      </div>
    </div>
  )
}
// settinglist
function SettingsCardShimmer() {
  return (
    <div className="flex flex-col gap-4">
      <ShimmerEffect height="16px" width="78px" radius="4px" />
      <BasicCardContainer
        height={'170px'}
        width={'100%'}
        radius="16px"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around'
        }}
      >
        {Array.from({ length: 3 }).map((_, index) => (
          <div className="flex justify-between" key={index}>
            <ShimmerEffect height="14px" width="70%" radius="4px" />
            <ShimmerEffect height="14px" width="14px" radius="4px" />
          </div>
        ))}
      </BasicCardContainer>
    </div>
  )
}

//faceswap
function MovieListShimmer() {
  const isMobile = useResponsive(media.mobile)

  return (
    <div className={`mb-10 ${isMobile ? 'w-full' : 'w-[50vw]'}`}>
      <div className="flex items-center mb-4">
        <ShimmerEffect width="60px" height="20px" className="text-left" />
        <ShimmerEffect width="60px" height="20px" className="ml-auto" />
      </div>

      <div
        className="flex gap-2 overflow-x-auto flex-nowrap hide-scrollbar"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            className={`${isMobile ? 'w-[186px] h-[250px]' : 'w-[140px] h-[210px]'} flex-shrink-0 overflow-hidden`}
            key={index}
          >
            <CardShimmer
              width="100%"
              height="100%"
              radius="16px"
              type={isMobile ? 'galleryCard' : 'aitool'}
              className="aspect-square"
            />
          </div>
        ))}
      </div>
    </div>
  )
}

//upload file shimmer
function UploadFileShimmer() {
  return (
    <>
      <ShimmerEffect
        width="160px"
        height="18px"
        radius="4px"
        className="mb-[10px]"
      />

      <BasicCardContainer
        height={'209px'}
        width={'100%'}
        radius="16px"
        className="flex flex-col items-center justify-center"
      >
        <Shimmer
          width={'263px'}
          height={'40px'}
          radius="24px"
          className="mb-1"
        />
        <Shimmer
          width={'40px'}
          height={'20px'}
          radius="24px"
          className="mb-1"
        />
        <Shimmer
          width={'307px'}
          height={'40px'}
          radius="24px"
          className="mb-1"
        />
      </BasicCardContainer>
    </>
  )
}

function DefaultAiImageShimmer({ isDescriptionRequired = false }) {
  return (
    <>
      <ShimmerEffect
        height="360px"
        width="640px"
        radius="4px"
        className="mb-8"
      />
      <div className="flex flex-col items-center justify-center">
        <ShimmerEffect height="32px" width="300px" radius="4px" />
        {isDescriptionRequired && (
          <ShimmerEffect
            height="14px"
            width="189px"
            radius="4px"
            className="mt-2"
          />
        )}
        <ShimmerEffect
          height="14px"
          width="380px"
          radius="4px"
          className="mt-2"
        />
      </div>
    </>
  )
}

function MwebUpload() {
  return (
    <div className="flex flex-col items-center">
      <ShimmerEffect width="100%" height="80px" radius="4px" />
      <ShimmerEffect
        width="70%"
        height="16px"
        radius="4px"
        className="mt-4 mb-8"
      />
    </div>
  )
}

function UserProfileWebShimmer() {
  return (
    <HeaderSection>
      <HeaderLeft>
        <ShimmerEffect
          height="34px"
          width="164px"
          radius="4px"
          className="mb-2"
        />

        <ShimmerEffect
          height="8px"
          width="200px"
          radius="4px"
          className="mb-1"
        />
        <ShimmerEffect
          height="8px"
          width="193px"
          radius="4px"
          className="mb-1"
        />
        <ShimmerEffect
          height="8px"
          width="177px"
          radius="4px"
          className="mb-2"
        />

        <ShimmerEffect height="14px" width="64px" radius="4px" />
      </HeaderLeft>
      <ShimmerEffect height="120px" width="120px" radius="50%" />
    </HeaderSection>
  )
}

function LikeCardShimmer({ className }) {
  return (
    <div className={className}>
      <div className="flex items-center space-x-3 overflow-hidden">
        <ShimmerEffect height="40px" width="40px" radius="50%" />
        <ShimmerEffect height="16px" width="100px" radius="4px" />
      </div>
      <ShimmerEffect height="30px" width="78px" radius="16px" />
    </div>
  )
}

function CommentCardShimmer({ className }) {
  return (
    <div className={className}>
      <ShimmerEffect height="40px" width="40px" radius="50%" />
      <div className="w-[296px] flex flex-col gap-2 ">
        <ShimmerEffect height="14px" width="70%" radius="4px" />
        <ShimmerEffect height="14px" width="40%" radius="4px" />
      </div>
    </div>
  )
}

function ReedemRewardsCardShimmer() {
  return (
    <BasicCardContainer
      height={'100%'}
      width={'100%'}
      radius="16px"
      className="flex flex-col items-center justify-center"
    >
      <ShimmerEffect width="100%" className="aspect-square" />
      <div className="flex flex-col w-full mt-4">
        <ShimmerEffect width="80%" height="14px" />
        <ShimmerEffect width="50%" height="14px" className="mt-1" />
      </div>
      <ShimmerEffect width="100%" height="40px" className="mt-9" />
    </BasicCardContainer>
  )
}

export {
  NotificationCardShimmer,
  CreatorCardShimmer,
  CustomDiscoverCardShimmer,
  SettingsCardShimmer,
  MovieListShimmer,
  UploadFileShimmer,
  DefaultAiImageShimmer,
  MwebUpload,
  UserProfileWebShimmer,
  CommentCardShimmer,
  LikeCardShimmer,
  ReedemRewardsCardShimmer,
  BlockUserShimmer
}
